import InvoicesUnifiedTable from "@/components/Organisms/InvoicesUnifiedTable";
import { INVOICE_TYPE } from "../invoices";

/**
 * PaidInvoicesTable Component
 *
 * Wrapper component that displays paid invoices using the unified invoices table.
 * This is a lightweight wrapper around InvoicesUnifiedTable with variant='paid'.
 */
const PaidInvoicesTable = () => {
  return <InvoicesUnifiedTable variant={INVOICE_TYPE.paid} />;
};

export default PaidInvoicesTable;
